<script>
	import Menu from '../../componentes/Menu.svelte';
	import { sTema, sAlgumRecursoCarregando, sTituloPaginaAtual } from '../../stores';
	export let largura = 4;
	export let deslocamento = 4;
	export let titulo = "Painel (box)";

	$sTituloPaginaAtual = titulo;
</script>

<main class="{$sAlgumRecursoCarregando == false ? '' : 'is-hidden'}">

	<Menu />

	<section class="hero is-fullheight {$sTema == "dia" ? "bgc-2" : "has-background-dark"}">
		<div class="hero-body">
			<div class="container">
				<div class="column is-{largura} is-offset-{deslocamento}">
					<slot></slot>
				</div>
			</div>
		</div>
	</section>
</main>